module.exports = __webpack_public_path__ + "images/feature/20190311-todo-label-8c0e996bd26618ee9cb26bf39f2458a3.png";